import { backend } from 'src/config'
import { LAST_MILE_OPERATORS } from 'src/constants'
import * as yup from 'yup'
import boxberry from '../assets/boxberry.png'
import cdek from '../assets/cdek.png'
import ruPostal from '../assets/ruPostal.png'
import pvzDp from '../assets/pvzDp.png'
import axios from './axios'

export const checkValuesInArray = (arr1 = [], arr2 = []) => {
  for (const tabRole of arr1) {
    for (const userRole of arr2) {
      if (tabRole === userRole.name) return true
    }
  }
  return false
}

export const isUserAcceptCargo = (user) => {
  return user.roles.some((role) => role.name === 'ACCEPTOR_CARGO')
}

export const noRightToEditDeclaration = (user) => {
  if (!user) return null
  const roles = user.roles
  const isAcceptCargo = roles.some((role) => role.name === 'ACCEPTOR_CARGO')
  if (isAcceptCargo) return true
  // CHECK FOR OTHER ROLES IF NECESSARY
  return false
}
export const getWeightOrZero = (weight) => (weight ? weight : '0.00')

export const getLastMileApi = (info) => {
  let api = ''

  switch (info.operator) {
    case LAST_MILE_OPERATORS.BOXBERRY:
      api = 'api/boxberry'
      break

    case LAST_MILE_OPERATORS.POSTAL_RU:
      api = 'api/newPostal'
      break

    case LAST_MILE_OPERATORS.CDEK:
      api = 'api/cdek/register'
      break

    case LAST_MILE_OPERATORS.DPD:
      api = 'api/dpd'
      break

    default:
      return null
  }

  return api
}

export const dataPickerValidationSchema = yup.object().shape({
  from: yup.string().required('Required'),
  to: yup.string().required('Required'),
})

export const _updateReadyGoodAndSubmit = async (
  goodHazardCategory,
  good,
  submitFn,
  statusId,
  weight,
  submitData,
  userRoleAcceptor,
  snackBarFn
) => {
  let baseData

  if (userRoleAcceptor) {
    baseData = { ...submitData, weight }
    delete baseData.incomingDeclaration
  } else {
    baseData = { ...submitData, weight }
  }

  try {
    // if (
    //   goodHazardCategory === TOOL_KIND_GOOD_HAZARD_CATEGORY.DANGEROUS ||
    //   goodHazardCategory === TOOL_KIND_GOOD_HAZARD_CATEGORY.SUPER_DANGEROUS
    //   // goodHazardCategory === TOOL_KIND_GOOD_HAZARD_CATEGORY.PROHIBITED
    //   // goodHazardCategory === TOOL_KIND_GOOD_HAZARD_CATEGORY.SAFE_PRODUCT ||
    //   // goodHazardCategory === TOOL_KIND_GOOD_HAZARD_CATEGORY.LIQUID
    // ) {
    //   const dangerousPayload = {
    //     goodHazardCategory,
    //     weight,
    //     // storeId: 2,
    //     description: submitData.description,
    //     additionalServicesIds: good.additionalServicesIds,
    //     ...(userRoleAcceptor
    //       ? {}
    //       : { incomingDeclaration: submitData.incomingDeclaration }),
    //   }

    //   // HERE WE SUBMIT READY GOOD AS ORDINARY AND RETURN
    //   const { data } = await axios.put(
    //     `${backend}/api/goods/${good.id}`,
    //     dangerousPayload
    //   )

    //   const updatedGood = data.data ? data.data.responseBody.goods : null

    //   await submitFn(updatedGood, statusId, weight)
    //   return
    // }

    const { data: updateData } = await axios.put(
      `${backend}/api/goods/${good.id}`,
      baseData
    )

    const newData = updateData.data ? updateData.data?.responseBody.goods : null
    await submitFn(newData, statusId, weight)
  } catch (error) {
    snackBarFn(
      `Error while _updateReadyGoodAndSubmit: ${error.message ||
        JSON.stringify(error)}`,
      {
        variant: 'error',
      }
    )
  }
}

export function customSortWithOrderBy(array, orderBy, order = 'desc') {
  if (!array) return null
  return array.slice().sort((a, b) => {
    const sortOrder = order === 'desc' ? 1 : -1

    if (
      typeof a[orderBy] === 'string' &&
      (orderBy === 'created' || orderBy === 'date')
    ) {
      // Convert strings 'created' and 'date' to Date objects for comparison
      return sortOrder * (new Date(b[orderBy]) - new Date(a[orderBy]))
    } else if (typeof a[orderBy] === 'string') {
      // Use localeCompare for string comparison
      return sortOrder * a[orderBy].localeCompare(b[orderBy])
    } else if (typeof a[orderBy] === 'number') {
      return sortOrder * (b[orderBy] - a[orderBy])
    } else {
      return 0
    }
  })
}

export const collectAllItems = (sections) => {
  const allItems = []

  sections.forEach((section) => {
    if (section.items) {
      section.items.forEach((item) => {
        allItems.push(item)
      })
    }
  })

  return allItems
}

export const renderLastMileIcon = (option) => {
  switch (option.id) {
    case 3:
      return <img src={cdek} alt="Cdek icon" />
    case 4:
      return <img src={pvzDp} alt="PVZ Dp icon" />
    case 5:
      return <img src={boxberry} alt="Boxberry icon" />
    case 6:
      return <img src={ruPostal} alt="ruPostal" />
    default:
      return null
  }
}

export function extractNumber(str) {
  if (!str) return null
  const match = str.match(/\d+/) // Find the first number
  return match ? Number(match[0]) : null
}

export const handlePrintCheckViaPrinter = async (itemId, enqueueSnackbar) => {
  try {
    const response = await axios.post(
      `http://localhost:3000/print/smallStickParcel/${itemId}`
    )

    if (response?.status === 204) {
      enqueueSnackbar('Small stick успешно распечатана', {
        variant: 'success',
      })
    }
  } catch (error) {
    enqueueSnackbar('Не удалось распечатать посылку через принтер', {
      variant: 'error',
    })
  }
}

export const fetchGoodsFromCell = async (cellNum, enqueueSnackbar) => {
  try {
    const response = await axios.get(`${backend}/api/store/cell/goods`, {
      params: {
        cellNum,
      },
    })

    if (response?.status === 200) {
      return response.data
    }
  } catch (error) {
    enqueueSnackbar('Не удалось получить товары из ячейки', {
      variant: 'error',
    })
  }
}

export const findDifferences = (obj1, obj2) => {
  const diffs = {}

  // Check keys in obj1 (initial values)
  for (const key in obj1) {
    if (Object.prototype.hasOwnProperty.call(obj2, key)) {
      const val1 = obj1[key]
      const val2 = obj2[key]

      if (Array.isArray(val1) && Array.isArray(val2)) {
        // compare arrays
        if (val1.length !== val2.length || val1.some((v, i) => v != val2[i])) {
          diffs[key] = val2 // take from second object
        }
      } else if (
        val1 &&
        typeof val1 === 'object' &&
        val2 &&
        typeof val2 === 'object'
      ) {
        // recursive check for nested objects
        const deepDiff = findDifferences(val1, val2)
        if (Object.keys(deepDiff).length > 0) {
          diffs[key] = deepDiff
        }
      } else if (val1 != val2) {
        // loose equality check (200 == "200" → considered equal)
        diffs[key] = val2
      }
    }
  }

  // Check for new keys in obj2 that don't exist in obj1
  // Only include keys that have meaningful values (not undefined/null)
  for (const key in obj2) {
    if (
      !Object.prototype.hasOwnProperty.call(obj1, key) &&
      obj2[key] !== undefined &&
      obj2[key] !== null
    ) {
      diffs[key] = obj2[key]
    }
  }

  return diffs
}

/**
 * Get field error message if field should show error
 * @param {Object} errors - Formik errors object
 * @param {Object} touched - Formik touched object
 * @param {string} fieldName - Name of the field
 * @param {boolean} submitAttempted - Whether form submission was attempted
 * @returns {string|undefined} Error message or undefined
 */
export const getFieldError = (errors, touched, fieldName, submitAttempted) => {
  if (!errors?.[fieldName]) return undefined
  if (touched?.[fieldName] || submitAttempted) return errors[fieldName]
  return undefined
}
